const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0 }}>
    <circle cx="8" cy="8" r="8" fill="#1D9E75" fillOpacity="0.12" />
    <path
      d="M5 8.5L7 10.5L11 6"
      stroke="#1D9E75"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const XIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0 }}>
    <circle cx="8" cy="8" r="8" fill="#d1d5db" />
    <path
      d="M5.5 5.5L10.5 10.5M10.5 5.5L5.5 10.5"
      stroke="#6b7280"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </svg>
);

const CAN_DO = [
  'AI translation',
  'Edit content directly in the preview',
  'Add or change options, then use Reset to regenerate content from scratch',
  'Share via Copy link',
];

const NOT_YET = [
  'Hotels only — cruises, flights & cars coming soon',
  'Email send — use Copy link',
  'Self-booking',
  'Adding or removing options',
  'Automatic price updates',
];

const PaperTemplateBanner = () => (
  <div
    className="mt-3 rounded-lg border border-gray-200 bg-gray-100 text-sm"
    style={{ padding: '1.25rem 1.5rem' }}
  >
    <div className="flex items-center gap-2 mb-3">
      <span className="text-gray-800 font-medium">Paper template</span>
      <span
        style={{
          fontSize: 11,
          fontWeight: 500,
          background: '#2563eb',
          color: '#fff',
          padding: '2px 8px',
          borderRadius: 6,
        }}
      >
        Beta
      </span>
    </div>
    <div className="mb-4 pt-3 border-t border-gray-200">
      <p className="text-sm font-medium text-gray-700 mb-2">How it works</p>
      <ol className="flex flex-col gap-2 text-gray-800 list-none">
        <li className="flex items-start gap-2">
          <span className="text-gray-500 font-medium w-4 shrink-0">1.</span>Edit content and
          translate into the language required
        </li>
        <li className="flex items-start gap-2">
          <span className="text-gray-500 font-medium w-4 shrink-0">2.</span>Save to preserve your
          changes — or Reset to discard edits and regenerate from your selected options
        </li>
        <li className="flex items-start gap-2">
          <span className="text-gray-500 font-medium w-4 shrink-0">3.</span>Use Copy link in the
          preview to share with your client
        </li>
      </ol>
    </div>
    <div className="grid grid-cols-2 gap-8">
      <div>
        <p className="text-sm font-medium text-gray-700 mb-2">Available</p>
        <div className="flex flex-col gap-2">
          {CAN_DO.map((item) => (
            <div key={item} className="flex items-center gap-2">
              <CheckIcon />
              <span className="text-gray-800">{item}</span>
            </div>
          ))}
        </div>
      </div>
      <div>
        <p className="text-sm font-medium text-gray-700 mb-2">Coming soon</p>
        <div className="flex flex-col gap-2">
          {NOT_YET.map((item) => (
            <div key={item} className="flex items-center gap-2">
              <XIcon />
              <span className="text-gray-800">{item}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default PaperTemplateBanner;
